<div class="main-content">
	<header>
		<div class="h1-wrapper">
			<h1 class="title" name="course-title">{{course?.name}}</h1>
		</div>
	</header>
		<article role="application">
			<section class="left">
				<div class="content" name="content-note">
					<p><strong>Use the link below to start your activity. Before you do, please read this note:</strong></p>
					<p>This activity wasn’t written by the team who produced the Wales Essential Skills Toolkit, but we’ve included it here as part of an excellent collection of free learning materials available to all.</p>
					<p>The link below takes you to a different website belonging to another reputable company. Of course, whether it continues to work is beyond our control, but if the page has disappeared completely then please let us know and we’ll remove the link.</p>
					<p>If the page works but you need help, please contact your tutor. Note that some activities rely on ‘plugins’ in your web browser and these may not be available on all devices.</p>

					<ng-container *ngIf="!isScormContentReplaced">
						<p><a name="activity-name" (click)="goToLink()">{{objectName}}</a></p>
					</ng-container>
					<ng-container *ngIf="isScormContentReplaced">
						<p><a name="activity-name" (click)="redirectToContentPlayer()" [queryParams]="{mode: lessonMode}">{{objectName}}</a></p>
					</ng-container>
				</div>
			</section>
    </article>
</div>